
<template>
  <header class="p-4 dark:bg-gray-100 dark:text-gray-800">
    <div class="container flex justify-between h-16 mx-auto md:justify-center md:space-x-8">
      <ul class="items-stretch hidden space-x-3 md:flex">
        <li class="flex">
          <router-link to="/" class="flex items-center px-4 -mb-1 border-b-2 dark:border-">Home</router-link>
        </li>
        <li class="flex">
          <router-link to="/about" class="flex items-center px-4 -mb-1 border-b-2 dark:border-">About</router-link>
        </li>
        <li class="flex">
          <router-link to="/join" class="flex items-center px-4 -mb-1 border-b-2 dark:border-">Join us</router-link>
        </li>
      </ul>
      <a rel="noopener noreferrer" href="/" aria-label="Back to homepage" class="flex items-center">
        <img src="@/assets/logo.png" alt="" width="80" height="80" class="object-contain h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128 rounded-xl">
      </a>
      <ul class="items-stretch hidden space-x-3 md:flex">
        <li class="flex">
          <router-link to="/quests" class="flex items-center px-4 -mb-1 border-b-2 dark:border-">Quests</router-link>
        </li>
        <li class="flex">
          <router-link to="/nft" class="flex items-center px-4 -mb-1 border-b-2 dark:border-">NFTs</router-link>
        </li>
        <li class="flex">
          <router-link to="/staking" class="flex items-center px-4 -mb-1 border-b-2 dark:border-">Staking</router-link>
        </li>
      </ul>
<!--      <button title="Button" type="button" class="p-4 md:hidden">-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6 dark:text-gray-800">-->
<!--          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>-->
<!--        </svg>-->
<!--      </button>-->
      <button @click="isMenuOpen = !isMenuOpen" title="Toggle Menu" type="button" class="p-4 md:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6 dark:text-gray-800">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
    </div>
    <div v-if="isMenuOpen" class="mt-2 space-y-3 bg-gray-100 dark:bg-gray-900 p-4 rounded-lg md:hidden">
      <router-link to="/" class="block px-4 py-2 rounded hover:bg-emerald-600 text-white">Home</router-link>
      <router-link to="/about" class="block px-4 py-2 rounded hover:bg-emerald-600 text-white">About</router-link>
      <router-link to="/join" class="block px-4 py-2 rounded hover:bg-emerald-600 text-white">Join us</router-link>

      <router-link to="/quests" class="block px-4 py-2 rounded hover:bg-emerald-600 text-white">Quests</router-link>
      <router-link to="/nft" class="block px-4 py-2 rounded hover:bg-emerald-600 text-white">NFTs</router-link>
      <router-link to="/staking" class="block px-4 py-2 rounded hover:bg-emerald-600 text-white">Staking</router-link>
    </div>
  </header>
</template>
<script setup >
import { ref } from 'vue';

const isMenuOpen = ref(false);
</script>
